import { ApplicationSourceEnum } from '../../dto/applicationSource.enum';

export const KIOSK_APP_SOURCES = [
  ApplicationSourceEnum.WEB_KIOSK
];
